__turbopack_context__.v({
  "fadeInItems": "ModelMeasurements-module__7NzMpG__fadeInItems",
  "item": "ModelMeasurements-module__7NzMpG__item",
  "itemActive": "ModelMeasurements-module__7NzMpG__itemActive",
  "itemImperial": "ModelMeasurements-module__7NzMpG__itemImperial",
  "itemMetric": "ModelMeasurements-module__7NzMpG__itemMetric",
  "itemNewLine": "ModelMeasurements-module__7NzMpG__itemNewLine",
  "lightStyle": "ModelMeasurements-module__7NzMpG__lightStyle",
  "list": "ModelMeasurements-module__7NzMpG__list",
  "shoeSizesWrapper": "ModelMeasurements-module__7NzMpG__shoeSizesWrapper",
  "spacing--lg": "ModelMeasurements-module__7NzMpG__spacing--lg",
  "spacing--md": "ModelMeasurements-module__7NzMpG__spacing--md",
  "spacing--sm": "ModelMeasurements-module__7NzMpG__spacing--sm",
  "spacing--xl": "ModelMeasurements-module__7NzMpG__spacing--xl",
  "spacing--xs": "ModelMeasurements-module__7NzMpG__spacing--xs",
  "spacing--xxl": "ModelMeasurements-module__7NzMpG__spacing--xxl",
  "spacing--xxs": "ModelMeasurements-module__7NzMpG__spacing--xxs",
  "spacing--xxxl": "ModelMeasurements-module__7NzMpG__spacing--xxxl",
  "spacing--xxxs": "ModelMeasurements-module__7NzMpG__spacing--xxxs",
  "title": "ModelMeasurements-module__7NzMpG__title",
  "titleValue": "ModelMeasurements-module__7NzMpG__titleValue",
  "toggle": "ModelMeasurements-module__7NzMpG__toggle",
  "toggleWrapMobile": "ModelMeasurements-module__7NzMpG__toggleWrapMobile",
  "value": "ModelMeasurements-module__7NzMpG__value",
});
